import { render, staticRenderFns } from "./MenuBrain.vue?vue&type=template&id=2eb57ad0&scoped=true"
import script from "./MenuBrain.vue?vue&type=script&lang=js"
export * from "./MenuBrain.vue?vue&type=script&lang=js"
import style0 from "./MenuBrain.vue?vue&type=style&index=0&id=2eb57ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb57ad0",
  null
  
)

export default component.exports